var isNavbarHidden = false;
var secondChild = document.getElementsByClassName('layout--header-group')[0].children[1];

function handleScroll() {
  var scrollPosition = window.pageYOffset;

  if (scrollPosition >= 300 && !isNavbarHidden) {
    secondChild.style.transition = 'opacity 0.3s ease';
    secondChild.style.opacity = '0';
    isNavbarHidden = true;
  } else if (scrollPosition < 300 && isNavbarHidden) {
    secondChild.style.transition = 'opacity 0.3s ease';
    secondChild.style.opacity = '1';
    isNavbarHidden = false;
  }

  window.requestAnimationFrame(handleScroll);
}

window.requestAnimationFrame(handleScroll);